module.exports = __webpack_public_path__ + "img/imagen3.8cbec302.png";